// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export function hexToRGBA(hex: string, alpha: number): string {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    const r = result ? parseInt(result[1], 16) : 255;
    const g = result ? parseInt(result[2], 16) : 255;
    const b = result ? parseInt(result[3], 16) : 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
